import { useEffect, useState } from 'react';

import request from '@/request';

export default function ReviewEventInWx({
  title,
  event,
  size = 25,
  position = 'bottom',
}) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (event?.id) {
      request
        .post('/wxa', {
          param: '/pages/event-detail?id=' + event.id,
        })
        .then((res) => {
          setUrl(res);
        });
    }
  }, [event?.id]);

  // 根据 position 属性确定二维码的位置样式
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
      case 'bottom':
        return 'top-full left-1/2 -translate-x-1/2 mt-2';
      case 'left':
        return 'right-full top-2/3 -translate-y-2/3 mr-2';
      case 'right':
        return 'left-full top-1/2 -translate-y-1/2 ml-2';
      default:
        return 'top-full left-1/2 -translate-x-1/2 mt-2';
    }
  };

  return (
    <div className="relative group">
      <button
        type="button"
        aria-label="赛事预览"
        className="relative inline-flex items-center justify-center p-2 rounded-md hover:bg-slate-100"
      >
        <svg
          t="1769740037724"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4973"
          width={size}
          height={size}
        >
          <path
            d="M512 828.288c18.56 0 33.536 15.104 33.536 33.6v125.248a33.664 33.664 0 1 1-67.136 0v-125.248c0-18.496 15.04-33.6 33.6-33.6zM353.92 785.92a33.728 33.728 0 0 1 12.352 45.952l-62.592 108.48a33.472 33.472 0 0 1-45.952 12.288 33.6 33.6 0 0 1-12.288-45.888l62.528-108.544a33.728 33.728 0 0 1 45.952-12.288z m341.76-3.392c8.704 2.368 16 7.872 20.48 15.68l62.592 108.48a33.28 33.28 0 0 1 3.328 25.408 33.408 33.408 0 0 1-32.512 25.024 33.408 33.408 0 0 1-29.056-16.768l-62.592-108.544a33.216 33.216 0 0 1-3.392-25.408 33.28 33.28 0 0 1 15.68-20.48 33.28 33.28 0 0 1 25.472-3.392zM238.08 670.08a33.664 33.664 0 0 1-12.288 45.952l-108.544 62.592a33.728 33.728 0 0 1-45.824-12.288 33.6 33.6 0 0 1 12.288-45.952l108.48-62.592a33.728 33.728 0 0 1 45.888 12.288z m593.792-12.224l108.48 62.592a33.408 33.408 0 0 1 12.288 45.952 33.6 33.6 0 0 1-45.888 12.288l-108.544-62.592a33.408 33.408 0 0 1-12.288-45.952 33.408 33.408 0 0 1 20.48-15.616 33.28 33.28 0 0 1 25.472 3.328zM606.912 285.056c72.96 0 132.224 59.328 132.224 132.288A132.544 132.544 0 0 1 606.72 549.76l-6.4-0.64a37.568 37.568 0 0 1 6.4-74.432 57.344 57.344 0 0 0 0-114.56 57.408 57.408 0 0 0-57.344 57.28V606.72a132.416 132.416 0 0 1-132.224 132.224A132.416 132.416 0 0 1 284.8 606.72c0-72.96 59.52-132.288 132.544-132.288a37.568 37.568 0 0 1 0.128 75.008h-1.856a57.664 57.664 0 0 0-55.552 57.28c0 31.552 25.728 57.28 57.28 57.28a57.408 57.408 0 0 0 57.28-57.28V417.344c0-72.96 59.328-132.288 132.288-132.288z m380.288 193.28a33.6 33.6 0 0 1 0 67.2h-125.312a33.6 33.6 0 0 1 0-67.2z m-825.088 0a33.6 33.6 0 0 1 0 67.2H36.864a33.664 33.664 0 1 1 0-67.2h125.248z m-44.864-232.96l108.544 62.528a33.664 33.664 0 1 1-33.6 58.24l-108.48-62.592a33.664 33.664 0 0 1 33.536-58.24z m814.912-3.392a33.472 33.472 0 0 1 20.48 15.744 33.6 33.6 0 0 1-12.288 45.888l-108.544 62.528a33.408 33.408 0 0 1-45.888-12.224 33.408 33.408 0 0 1 12.224-45.952l108.544-62.592a33.216 33.216 0 0 1 25.472-3.392zM283.072 68.032c8.768 2.304 16 7.872 20.48 15.68l62.656 108.48a33.6 33.6 0 0 1-58.24 33.664l-62.72-108.544a33.728 33.728 0 0 1 37.76-49.28z m483.264 3.328a33.6 33.6 0 0 1 12.288 45.952l-62.528 108.48a33.664 33.664 0 0 1-45.952 12.288l-4.416-3.008a33.536 33.536 0 0 1-7.808-42.944l62.464-108.48a33.664 33.664 0 0 1 45.952-12.288zM512 3.2c18.56 0 33.536 15.104 33.536 33.664v125.248a33.6 33.6 0 0 1-67.136 0V36.864c0-18.56 15.04-33.664 33.6-33.664z"
            p-id="4974"
          ></path>
        </svg>
      </button>

      {url && (
        <div
          className={`absolute w-40 rounded-md shadow-lg bg-white p-2 opacity-0 scale-95 transition-all duration-200 group-hover:opacity-100 group-hover:scale-100 pointer-events-none z-50 flex flex-col items-center ${getPositionClasses()}`}
        >
          <img
            src={url}
            alt="赛事预览"
            className="w-full h-full object-cover"
          />
          <span className="text-sm mt-2">{title || '赛事预览'}</span>
        </div>
      )}
    </div>
  );
}
